var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQmeeNavIcon = function SvgQmeeNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.206 19.56C4.569 19.56 0 15.183 0 9.78S4.57 0 10.206 0s10.205 4.379 10.205 9.781a9.4 9.4 0 0 1-1.107 4.435L21 20l-5.957-1.605a10.5 10.5 0 0 1-4.837 1.166m.119-4.56c2.996 0 5.425-2.314 5.425-5.166 0-2.854-2.43-5.167-5.425-5.167C7.328 4.667 4.9 6.98 4.9 9.834 4.9 12.686 7.327 15 10.325 15"
  })));
};
export default SvgQmeeNavIcon;